import { Component } from '@angular/core';
import { Router } from '@angular/router';
//p;import { NotificationService } from '@progress/kendo-angular-notification';
import { NotifyServiceService } from 'src/app/services/notify/notify-service.service';
import { ServerService } from 'src/app/services/server/server.service';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    standalone: false
})
export class LoginPageComponent {
  username: string;
  password: string;

  constructor(
    private server: ServerService,
    private router: Router,
    private notificationService: NotifyServiceService
  ) { }

  onLogin() {
    this.server.onLogin(this.username, this.password).subscribe({
      next: (res) => {
 
        if (res.success) {
          localStorage.setItem('access_token', res.obj.token);
          this.router.navigate(['main']);
        } else {
          this.notificationService.showError(res.message);
        }
      },
      error: (err) => {
        this.notificationService.showError(
          'An error has occured attempting to login'
        );
      },
    });
  }
}
